import httpbaseURL from "../../../../modules/Inventory/common/axios";
class AssetMaintenanceService {
  createdata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/AssetMaintenance/Create", doc);
  }
  updateSchedule(doc) {
    return httpbaseURL.httpMSInventoryUrl.post("/AssetMaintenance/Update", doc);
  }
  updateAssign(doc) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/AssetMaintenance/UpdateAssign",
      doc
    );
  }
  updatePerformMaintenance(doc) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/AssetMaintenance/UpdatePerformMaintanence",
      doc
    );
  }
  createCheckListMapping(doc) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/AssetMaintenance/CreateCheckListMapping",
      doc
    );
  }
  createSparePartMapping(doc) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/AssetMaintenance/CreateSparePartMapping",
      doc
    );
  }
  getfindonedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AssetMaintenance/Get?id=" + doc
    );
  }
  getAssetMaintenanceSchedule(
    status,
    roleId,
    AssetId,
    TypeId,
    StatusId,
    Warranty
  ) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AssetMaintenance/ListAssetMaintenanceSchedule?Status=" +
        status +
        "&RoleId=" +
        roleId +
        "&AssetId=" +
        AssetId +
        "&TypeId=" +
        TypeId +
        "&StatusId=" +
        StatusId +
        "&Warranty=" +
        Warranty +
        ""
    );
  }

  //dashboard
  getListAssetMaintenanceDashboard(hospitalId, branchId, storeId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AssetMaintenance/ListAssetMaintanceDashboard?HospitalId=" +
        hospitalId +
        "&BranchId=" +
        branchId +
        "&StoreId=" +
        storeId +
        ""
    );
  }
  getListMaintenance(assetMaintenanceId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AssetMaintenance/ListMaintenance?assetMaintenanceId=" +
        assetMaintenanceId +
        ""
    );
  }

  getListMaintenanceActivityHistory(assetMaintenanceId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AssetMaintenance/ListMaintenanceActivityHistory?assetMaintenanceId=" +
        assetMaintenanceId +
        ""
    );
  }

  deletedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/AssetMaintenance/Delete?id=" + doc
    );
  }
  active(DelID, Status) {
    debugger;
    return httpbaseURL.httpMSInventoryUrl.put(
      "AssetMaintenance/Active?id=" + DelID + "&Status=" + Status + ""
    );
  }
}
export default new AssetMaintenanceService();
